import {
  DeleteTwoTone,
  EditTwoTone,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import {
  Button, Card,
  Popconfirm,
} from 'antd';
import React, { Fragment, useState } from 'react';
import './style.scss';

const LabelGenerationCard = ({
  isLoading, LabelGenerationItem, LabelGenerationId, cardTitle, callback, setSelectedLabelGeneration, setShowUpdateLabelGeneration, handelDeleteTemplate,
}) => {
  return (
    <Fragment>
      <Card className="label_gen_card">
        <div className="label_gen_card_header">
          <div className="label_gen_card_header-left">
            <div className="label_gen_card_header-title">
              {cardTitle}
              {/* <H3Text text={drrItem?.tenant_info?.tenant_name} className="table-subscript" /> */}
            </div>
          </div>
          <div className="label_gen_card_header-right flex-display">
            <div>
              <Button
                className="action_icon"
                type="ghost"
                ghost
                icon={<EditTwoTone className="label_gen_card_header_icon" />}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedLabelGeneration(LabelGenerationItem);
                  setShowUpdateLabelGeneration(true);
                }}
              />
            </div>
            <div>
              <Popconfirm
                title="Delete the template"
                description="Are you sure to delete this template?"
                icon={(
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                )}
                onConfirm={(e) => {
                  e.stopPropagation();
                  handelDeleteTemplate(LabelGenerationId, () => {
                  });
                }}
                onCancel={(e) => {
                  e.stopPropagation();
                }}
                okText="Yes"
                cancelText="No"
                okButtonProps={{
                  loading: isLoading,
                }}

              >
                <Button
                  className="action_icon"
                  type="ghost"
                  ghost
                  icon={<DeleteTwoTone twoToneColor="#f74357" className="label_gen_card_header_icon" />}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </Popconfirm>
            </div>
          </div>
        </div>
      </Card>
    </Fragment>
  );
};

export default LabelGenerationCard;
